// Tailwind preflight (in @tailwind base) replaces MUI CssBaseline.
// This component is now a no-op and can be safely removed from consuming files.
export const AdasCssBaseline = () => null
